// extracted by mini-css-extract-plugin
export default {"badge":"BadgeFilter_badge__cwxKV"};